import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RestService } from '../../../shared/shared.module';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContactsComponent implements OnInit {

  public myTemplate: any = '';
  constructor(private restService: RestService) {
    this.restService.urlGet<string>('/assets/Documents/contacts.html', { responseType: 'text' })
      .then(data =>
        this.myTemplate = data
      );
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/contacts/contacts.component.ts